// components/inventory/CreateInventoryForm.jsx
import React from 'react';
import FormInput from '../ui/FormInput';
import ImageUpload from '../ui/ImageUpload';

const CreateInventoryForm = ({ 
  inventory, 
  onChange, 
  errors, 
  onImageChange,
  onSubmit,
  onCancel,
  isLoading = false
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="p-6 space-y-4">
        <FormInput
          label="Inventory Name"
          placeholder="Your inventory's name"
          value={inventory.inventoryName}
          onChange={(e) => onChange({ ...inventory, inventoryName: e.target.value })}
          error={errors.inventoryName}
          required
        />
        
        <FormInput
          label="Inventory Description"
          type="textarea"
          placeholder="Your inventory's description"
          value={inventory.description}
          onChange={(e) => onChange({ ...inventory, description: e.target.value })}
          rows="3"
        />

        <ImageUpload
          label="Inventory Image"
          image={inventory.inventoryImage}
          onImageChange={onImageChange}
          id="create-inventory-image"
        />
      </div>

      <div className="flex justify-end gap-3 p-6 border-t">
        {onCancel && (
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
        )}
        <button
          type="submit"
          disabled={isLoading}
          className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Creating...' : 'Create Inventory'}
        </button>
      </div>
    </form>
  );
};

export default CreateInventoryForm;